import cx from "classnames";
import {
  MentionTextarea,
  MentionTextareaHandle,
} from "@jugl-web/domain-resources/common/components/RichTextarea";
import { useTranslations } from "@jugl-web/utils";
import { useCallback, useRef } from "react";
import { useEffectOnce } from "react-use";
import useEditorContext from "../useEditorContext";

const MAX_CAPTION_LENGTH = 300;

const ToolbarCaption = () => {
  const { mentions, caption, onEdit } = useEditorContext();
  const { t } = useTranslations();
  const $bodyInput = useRef<MentionTextareaHandle | null>(null);

  useEffectOnce(() => {
    $bodyInput.current?.setRichText(caption || "");
    $bodyInput.current?.focus();
  });

  const handleRawTextChange = useCallback(() => {
    const newValue = $bodyInput.current?.getRichText();
    if (newValue !== caption) {
      onEdit({ caption: newValue });
    }
  }, [caption, onEdit]);

  return (
    <div className="relative">
      <div className="rounded-xl bg-white/30 px-4 py-2">
        <MentionTextarea
          ref={$bodyInput}
          maxTextLength={MAX_CAPTION_LENGTH}
          mentions={mentions}
          placeholder={`${t({
            id: "chats-page.add-caption",
            defaultMessage: "Add a caption",
          })}...`}
          onRawTextChange={handleRawTextChange}
          classes={{
            placeholder: "text-gray-400",
            contentEditable:
              "outline-none text-sm text-white font-secondary jugl__custom-scrollbar overflow-y-auto h-[37px]",
          }}
        />
      </div>
      <span
        className={cx(
          "absolute right-4 -bottom-3.5 text-xs",
          caption.length === MAX_CAPTION_LENGTH
            ? "text-red-500"
            : "text-gray-600"
        )}
      >
        {caption.length} / {MAX_CAPTION_LENGTH}
      </span>
    </div>
  );
};

export default ToolbarCaption;
